import { reactive } from "vue";

export const store = reactive({
    state: '',
    retain: false,
    setState(newState) {
        this.state = newState;
    },
    setRetain(newStatus) {
        this.retain = newStatus;
    }

})